import type { InsightKey } from "@tandemdiabetes/sugarmate-api-react-client"
import {
  LargeMenuButton,
  LargeMenuButtonText,
  LargeMenuButtonLabelRow,
  LargeMenuButtonIcon,
  LargeMenuButtonLabel,
  LargeMenuButtonSubtext,
} from "@tandemdiabetes/sugarmate-react-components"
import type { ChangeEventHandler } from "react"
import { useInsightIcon } from "../useInsightIcon"
import { usePolyglot } from "src/contexts"

const polyglotPrefix = "pages.home.insights."

interface Props {
  onChange: ChangeEventHandler<HTMLInputElement>;
  insightKey: InsightKey;
  disabled: boolean;
  checked: boolean;
}

export function AddInsightButton(props: Props) {
  const {
    onChange,
    insightKey,
    disabled,
    checked,
  } = props

  const polyglot = usePolyglot()
  const InsightIcon = useInsightIcon(insightKey)

  return (
    <LargeMenuButton
      htmlFor={`add-insight-button-${insightKey}`}
      value={insightKey}
      onChange={onChange}
      disabled={disabled}
      checked={checked}
      aria-label={polyglot.t(`${polyglotPrefix}cta_label.${insightKey}`)}
      id={`add-insight-${insightKey}`}
    >
      <LargeMenuButtonText>
        <LargeMenuButtonLabelRow>
          {InsightIcon && (
            <LargeMenuButtonIcon>
              <InsightIcon />
            </LargeMenuButtonIcon>
          )}
          <LargeMenuButtonLabel id={`add-insight-${insightKey}`}>
            {polyglot.t(`${polyglotPrefix}cta_label.${insightKey}`)}
          </LargeMenuButtonLabel>
        </LargeMenuButtonLabelRow>
        <LargeMenuButtonSubtext id={`add-insight-sublabel-${insightKey}`}>
          {polyglot.t(`${polyglotPrefix}cta_subtext.${insightKey}`)}
        </LargeMenuButtonSubtext>
      </LargeMenuButtonText>
    </LargeMenuButton>
  )
}
